"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.effectiveChainCaps = exports.DEFAULT_MAX_WAITING_STEPS = exports.DEFAULT_MAX_CHAIN_DEPTH = exports.CHAIN_SKIP_REASONS = exports.CHAIN_STEP_STATES = void 0;
exports.CHAIN_STEP_STATES = [
    "waiting",
    "released",
    "skipped",
    "dispatch_refused",
];
exports.CHAIN_SKIP_REASONS = [
    "predecessor_failed",
    "predecessor_unknown",
    "predecessor_rejected",
    "predecessor_expired",
    "ancestor_skipped",
    "ancestor_cancelled",
    "cancelled",
    "dispatch_refused",
];
exports.DEFAULT_MAX_CHAIN_DEPTH = 10;
exports.DEFAULT_MAX_WAITING_STEPS = 20;
const effectiveChainCaps = (caps) => {
    var _a, _b;
    return ({
        maxChainDepth: (_a = caps.maxChainDepth) !== null && _a !== void 0 ? _a : exports.DEFAULT_MAX_CHAIN_DEPTH,
        maxWaitingSteps: (_b = caps.maxWaitingSteps) !== null && _b !== void 0 ? _b : exports.DEFAULT_MAX_WAITING_STEPS,
    });
};
exports.effectiveChainCaps = effectiveChainCaps;
